<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JUSfFz/tc-custom/9781398411661.jpg?1705766094612" alt="This image is the cover for the book A Quest to Get Home Bound"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Quest to Get Home Bound
      </h1>
      <p class="bookDescription body article font2">
        <p>It is the midst of the Second World War and rationing is tightening everyone’s belts. Yet down the dark alleyways of the French capital Paris, you would find a man who could get you anything on the underground market. <br/>When a captured American ranger receives news from home, he knows he must escape from the Nazi prison camp in East Germany and embark on a quest to get to a neutral land, so he may return to his wife in America. Unexpectedly the ranger finds himself becoming mixed up in the Paris black-market syndicate. Can he survive long enough to afford his escape? Can he be homebound once again?<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles.G. Fournel
      </h2>
      
      <p class="authorDescription body article">Charles.G.Fournel grew up in a small seaside town in Suffolk, England. He is a divorced, devoted father of two. He started writing short stories at the age of ten and since has expanded his genre to World War II. He has family connections in both the allies and axis during the war. This is the reason for his extended interest in this era. He has grown to have great respect for resistance groups who, without any military experience, took up arms for their country. Other books by Charles.G.Fournel: Rise of the Maquis.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?facf8e5c